import {
  oneClubApi,
  teachersApi,
  oneClubGatewayApi,
  oneClubGatewayStaffMemberApi,
  coursesApi,
  boardApi,
  liveClassApi,
  teacherRecruitApi,
  referenceSystemApi,
  recommendationCodeApi,
  oneAnswerApi,
  oneAcademyApi,
  memberCenterApi,
} from 'api/index';
import instance from './instance';

export const URL = {
  ONECLUB: import.meta.env.VITE_ONECLUB_API,
  ONECLASS_API_DOMAIN: import.meta.env.VITE_ONECLASS_API_DOMAIN,
  COURSES: import.meta.env.VITE_COURSES_API,
  ONEBOARD: import.meta.env.VITE_ONEBOARD_API_DOMAIN,
  LIVE_CLASS: import.meta.env.VITE_LIVE_CLASS_API_DOMAIN,
  RECOMMENDATION_CODE: import.meta.env.VITE_CREATE_RECOMMENDATION_CODE,
  HELPER_MEMBER_DEV: import.meta.env.VITE_HELPER_MEMBER_DEV,
  ONE_ACADEMY: import.meta.env.VITE_ONEACADEMY_API_DOMAIN,
};

export default {
  oneClub: oneClubApi(instance, `${URL.ONECLUB}/dev`),
  teachers: teachersApi(instance, `${URL.ONECLASS_API_DOMAIN}/teacher/api`),
  teacherRecruit: teacherRecruitApi(
    instance,
    `${URL.ONECLASS_API_DOMAIN}/teacher/api/recruitment`,
  ),
  courses: coursesApi(instance, `${URL.COURSES}/api`),
  oneClubGateway: oneClubGatewayApi(instance, `${URL.ONECLASS_API_DOMAIN}/mms`),
  oneClubGatewayStaffMember: oneClubGatewayStaffMemberApi(
    instance,
    `${URL.ONECLASS_API_DOMAIN}/staff`,
  ),
  board: boardApi(instance, `${URL.ONEBOARD}`),
  liveClass: liveClassApi(instance, `${URL.LIVE_CLASS}`),
  referenceSystem: referenceSystemApi(
    instance,
    `${URL.ONECLASS_API_DOMAIN}/teacher/api/reference-system`,
  ),
  recommendationCode: recommendationCodeApi(
    instance,
    `${URL.RECOMMENDATION_CODE}`,
  ),
  oneAnswer: oneAnswerApi(instance, `${URL.ONECLASS_API_DOMAIN}/one-answer`),
  oneAcademy: oneAcademyApi(instance, `${URL.ONE_ACADEMY}`),
  memberCenter: memberCenterApi(
    instance,
    `${URL.ONECLASS_API_DOMAIN}/member-center`,
  ),
};
